import React from "react";
import { DialogBox } from "../../shared/components/dialog";
import { Avatar, Chip, DialogContent, Stack, Typography } from "@mui/material";
import UserIcon from "../../shared/icon/user-icon";
import { useDispatch } from "react-redux";
import {
  deleteAddressById,
  deleteAddressError,
} from "../../redux/features/address.slice";
import { useArcAuth } from "@arcauth/react-sdk";
import { getUserInfo } from "../../redux/features/user.slice";
export interface DialogProps {
  open: boolean;
  onClose: () => void;
  deleteAddress: {
    id: string;
    name: string;
    street2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    phone: string;
    email: string;
    addressname: string;
    isdefault: boolean;
    companyname: string;
  };
}
const RemoveAddress = (props: DialogProps) => {
  const dispatch = useDispatch();
  const { open, onClose, deleteAddress } = props;
  const dialogClose = () => {
    onClose();
  };

  const handleListItemClick = async () => {
    const dispatchObj = {
      id: deleteAddress?.id,
      callBackSuccess: () => {
        onClose();
        dispatch(getUserInfo());
      },
      callBackFailure: () => {
      onClose();
     }
    };
    dispatch(deleteAddressById(dispatchObj));
  };
  return (
    <>
      <DialogBox
        onClose={dialogClose}
        title={"Delete this address?"}
        buttonText={"Delete"}
        buttonClick={handleListItemClick}
        open={open}
        style={{ maxWidth: 500, mx: "auto" }}
      >
        <DialogContent sx={{ py: 0 }}>
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <Avatar sizes="small">
              <UserIcon />
            </Avatar>
            <Typography variant="h5" color="initial" fontWeight={"normal"}>
              {deleteAddress?.name}
            </Typography>
            <Chip label={deleteAddress?.street2} sx={{ ml: "auto" }} />
          </Stack>
          <Typography variant="body2" color="initial" marginBlock={2}>
            {deleteAddress?.addressname}, {deleteAddress?.city},{" "}
            {deleteAddress?.state} {deleteAddress?.zip},{" "}
            {deleteAddress?.country}
            {/* EM-4/1, EM Block, Sector V, Bidhannagar, Kolkata, West Bengal 700091, India */}
          </Typography>
        </DialogContent>
      </DialogBox>
    </>
  );
};

export default RemoveAddress;
